import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pinLat: '',
    pinLng: '',
    pinAddress: ''
};

export const editProjectCenterPinSlice = createSlice({
    name: "editProjectCenterPin",
    initialState,
    reducers: {
        updateProjectCenterPin: (state, action) => {
            state.pinLat = action.payload.pinLat;
            state.pinLng = action.payload.pinLng;
            state.pinAddress = action.payload.pinAddress;
        }
    },
});

export const { updateProjectCenterPin } = editProjectCenterPinSlice.actions;
export default editProjectCenterPinSlice.reducer;